import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SegmentPool_instance26x4wee5nyx6a as SegmentPool_instance } from './SegmentPool.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.x3v_1 = 8192;
        this.y3v_1 = 1024;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_okio_Segment(_this__u8e3s4) {
  _this__u8e3s4.a3w_1 = 0;
  _this__u8e3s4.b3w_1 = 0;
  _this__u8e3s4.c3w_1 = false;
  _this__u8e3s4.d3w_1 = false;
  _this__u8e3s4.e3w_1 = null;
  _this__u8e3s4.f3w_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      static g3w() {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.z3v_1 = new Int8Array(8192);
        $this.d3w_1 = true;
        $this.c3w_1 = false;
        return $this;
      }
      static h3w(data, pos, limit, shared, owner) {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.z3v_1 = data;
        $this.a3w_1 = pos;
        $this.b3w_1 = limit;
        $this.c3w_1 = shared;
        $this.d3w_1 = owner;
        return $this;
      }
      i3w() {
        this.c3w_1 = true;
        return Segment().h3w(this.z3v_1, this.a3w_1, this.b3w_1, true, false);
      }
      j3w() {
        var result = !(this.e3w_1 === this) ? this.e3w_1 : null;
        ensureNotNull(this.f3w_1).e3w_1 = this.e3w_1;
        ensureNotNull(this.e3w_1).f3w_1 = this.f3w_1;
        this.e3w_1 = null;
        this.f3w_1 = null;
        return result;
      }
      k3w(segment) {
        segment.f3w_1 = this;
        segment.e3w_1 = this.e3w_1;
        ensureNotNull(this.e3w_1).f3w_1 = segment;
        this.e3w_1 = segment;
        return segment;
      }
      l3w(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.b3w_1 - this.a3w_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().s2(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.i3w();
        } else {
          prefix = SegmentPool_instance.o3w();
          var tmp0 = this.z3v_1;
          var tmp2 = prefix.z3v_1;
          var tmp5 = this.a3w_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.a3w_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.b3w_1 = prefix.a3w_1 + byteCount | 0;
        this.a3w_1 = this.a3w_1 + byteCount | 0;
        ensureNotNull(this.f3w_1).k3w(prefix);
        return prefix;
      }
      p3w() {
        // Inline function 'kotlin.check' call
        if (!!(this.f3w_1 === this)) {
          var message = 'cannot compact';
          throw IllegalStateException().o(toString(message));
        }
        if (!ensureNotNull(this.f3w_1).d3w_1)
          return Unit_instance;
        var byteCount = this.b3w_1 - this.a3w_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.f3w_1).b3w_1 | 0) + (ensureNotNull(this.f3w_1).c3w_1 ? 0 : ensureNotNull(this.f3w_1).a3w_1) | 0;
        if (byteCount > availableByteCount)
          return Unit_instance;
        this.q3w(ensureNotNull(this.f3w_1), byteCount);
        this.j3w();
        SegmentPool_instance.r3w(this);
      }
      q3w(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.d3w_1) {
          var message = 'only owner can write';
          throw IllegalStateException().o(toString(message));
        }
        if ((sink.b3w_1 + byteCount | 0) > 8192) {
          if (sink.c3w_1)
            throw IllegalArgumentException().xd();
          if (((sink.b3w_1 + byteCount | 0) - sink.a3w_1 | 0) > 8192)
            throw IllegalArgumentException().xd();
          var tmp0 = sink.z3v_1;
          var tmp2 = sink.z3v_1;
          var tmp5 = sink.a3w_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.b3w_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.b3w_1 = sink.b3w_1 - sink.a3w_1 | 0;
          sink.a3w_1 = 0;
        }
        var tmp0_0 = this.z3v_1;
        var tmp2_0 = sink.z3v_1;
        var tmp4 = sink.b3w_1;
        var tmp6 = this.a3w_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.a3w_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.b3w_1 = sink.b3w_1 + byteCount | 0;
        this.a3w_1 = this.a3w_1 + byteCount | 0;
      }
    }
    initMetadataForClass($, 'Segment', $.g3w);
    SegmentClass = $;
  }
  return SegmentClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Segment as Segmentnhwb43ukbiy3,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
